import moment from 'moment'
import validator from 'validator'

const sleep = async (ms) => {
    return new Promise((resolve) => {
        setTimeout(resolve, ms)
    })
}

let mapModels = (nmStore, vars) => {
    let map = {}
    for (let v of vars) {
        map[v] = {
            get () {
                let mods = nmStore.split('/')
                let f = this.$store.state
                mods.forEach((m) => {
                    f = f[m]
                })
                return f[v]
            },
            set (val) {
                this.$store.commit('updateAnyState', [nmStore, v, val])
            }
        }
    }
    return map
}

let mapVars = (nmStore, vars) => {
    let map = {}
    for (let v of vars) {
        map[v] = function () {
            let mods = nmStore.split('/')
            let f = this.$store.state
            mods.forEach((m) => {
                f = f[m]
            })
            return f[v]
        }
    }
    return map
}

let mapUpdates = (nmStore, vars) => {
    let map = {}
    for (let v of vars) {
        map['update_' + v] = function (...args) {
            this.$store.commit('updateAnyState', [nmStore, v, ...args])
        }
    }
    return map
}

const toTitleCase = (str) => {
    return str.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    )
}

const getDateFromEpoch = (epoch, msg) => {
    return epoch
        ? moment.unix(epoch).format('MMM D YYYY, h:mm A')
        : msg || 'N / A'
}

const getDateTimeFromEpoch = (epoch, msg) => {
    return epoch
        ? moment.unix(epoch).format('MMM D YYYY, h:mm A')
        : msg || 'N / A'
}

const getDateTimeFrom = (date, msg) => {
    return date ? moment(date).format('MMM D YYYY, h:mm A') : msg || 'N / A'
}

const formatDate = (date, msg) => {
    return date ? moment(date).format('MMM D') : msg || 'N / A'
}

const decodeHash = (t) => {
    let w
    let v = ''
    return t.replace(new RegExp(v + '([0-9a-fA-F]{4})', 'g'), (u, x) => {
        w = parseInt(x, 16)
        return String.fromCharCode(w)
    })
}

const getOS = () => {
    // This script sets OSName variable as follows:
    // "Windows"    for all versions of Windows
    // "MacOS"      for all versions of Macintosh OS
    // "Linux"      for all versions of Linux
    // "UNIX"       for all other UNIX flavors
    // "Unknown OS" indicates failure to detect the OS

    const navigator = window.navigator
    let OSName = 'Unknown OS'
    if (navigator.appVersion.indexOf('Win') !== -1) OSName = 'Windows'
    if (navigator.appVersion.indexOf('Mac') !== -1) OSName = 'MacOS'
    if (navigator.appVersion.indexOf('X11') !== -1) OSName = 'UNIX'
    if (navigator.appVersion.indexOf('Linux') !== -1) OSName = 'Linux'

    return OSName
}

const detectCtrlClick = (event) => {
    const OS = getOS()
    if (OS === 'MacOS' && event.metaKey) return true
    else if (event.ctrlKey) return true
    return false
}

const daySuffix = (i) => {
    let j = i % 10
    let k = i % 100
    if (j === 1 && k !== 11) {
        return i + 'st'
    }
    if (j === 2 && k !== 12) {
        return i + 'nd'
    }
    if (j === 3 && k !== 13) {
        return i + 'rd'
    }
    return i + 'th'
}

const isValidURL = (str) => {
    return validator.isURL(str, { require_tld: true, allow_underscores: true })
}

const isValidMobileNumber = (str) => {
    if (/^(91)[6789]{1}([0-9]{9})$/g.test(str)) {
        return true
    } else {
        return false
    }
}

const isValidLandline = (str) => {
    if (/^0[0-9]{10}$/g.test(str)) {
        return true
    } else {
        return false
    }
}

const isTollFree = (str) => {
    if (/^(1800|1860)[0-9]{4,9}$/g.test(str)) {
        return true
    } else {
        return false
    }
}

const isValidNumber = (str) => {
    if (/^[0-9]+$/g.test(str)) {
        return true
    } else {
        return false
    }
}

const isValidShortCode = (str) => {
    if (/^[0-9]{3,7}$/g.test(str)) {
        return true
    } else {
        return false
    }
}

const isValidAPKUrl = (url) => {
    return validator.isURL(url) && (url.endsWith('.apk') || url.endsWith('.ipa'))
}

const doesUrlhasParams = (url) => {
    try {
        if (url.startsWith('www.')) url = 'https://' + url
        const urlObject = new URL(url)
        if (urlObject.searchParams.size === 0) return false
        for (const [key, value] of urlObject.searchParams.entries()) {
            if (key === '' || value === '') {
                return false
            }
        }
        return true
    } catch (error) {
        return false
    }
}

const checkForIP = (str) => {
    const ipRegex = /\b(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\b|(?:([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:)|::(?:[0-9a-fA-F]{1,4}:?){0,5}([0-9a-fA-F]{1,4})?)/
    return ipRegex.test(str)
}

const downloadURL = (uri, target, name) => {
    const link = document.createElement('a')
    if (name) link.download = name
    link.href = uri
    if (target) link.target = target
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export {
    sleep,
    mapModels,
    mapVars,
    mapUpdates,
    toTitleCase,
    getDateFromEpoch,
    formatDate,
    getDateTimeFromEpoch,
    getDateTimeFrom,
    decodeHash,
    daySuffix,
    detectCtrlClick,
    isValidURL,
    downloadURL,
    isValidMobileNumber,
    isValidLandline,
    isTollFree,
    isValidNumber,
    doesUrlhasParams,
    checkForIP,
    isValidShortCode,
    isValidAPKUrl
}
